export default __webpack_public_path__ + "static/media/icon_bandtype_NoStones.6108c0be.png";